import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography } from '@mui/material';
import { useIsMobile } from '../theme';

const LinkInsertDialog = ({ open, onClose, onSubmit }) => {
    const isMobile = useIsMobile();
    const [url, setUrl] = useState('');
    const [text, setText] = useState('');
    const [error, setError] = useState({ url: '', text: '' });

    const validateUrl = (urlString) => {
        try {
            new URL(urlString);
            return true;
        } catch {
            return false;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const newError = { url: '', text: '' };
        let hasError = false;

        if (!url.trim()) {
            newError.url = 'O endereço é obrigatório';
            hasError = true;
        } else if (!validateUrl(url.trim())) {
            newError.url = 'Endereço inválido (ex.: https://exemplo.pt)';
            hasError = true;
        }

        if (!text.trim()) {
            newError.text = 'O texto do link é obrigatório';
            hasError = true;
        }

        if (hasError) {
            setError(newError);
            return;
        }

        onSubmit({ url: url.trim(), text: text.trim() });
        handleClose();
    };

    const handleClose = () => {
        setUrl('');
        setText('');
        setError({ url: '', text: '' });
        onClose();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth fullScreen={isMobile}>
            <DialogTitle>Inserir link</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    autoFocus={!isMobile}
                    label='Endereço'
                    type='url'
                    fullWidth
                    value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                        setError((prev) => ({ ...prev, url: '' }));
                    }}
                    onKeyDown={handleKeyDown}
                    error={Boolean(error.url)}
                    helperText={error.url || 'ex.: https://exemplo.pt'}
                    placeholder='https://exemplo.pt'
                />
                <TextField
                    label='Texto do link'
                    fullWidth
                    value={text}
                    onChange={(e) => {
                        setText(e.target.value);
                        setError((prev) => ({ ...prev, text: '' }));
                    }}
                    onKeyDown={handleKeyDown}
                    error={Boolean(error.text)}
                    helperText={error.text || 'O texto que fica visível'}
                />
                {!isMobile && (
                    <Typography variant='caption' color='text.secondary'>
                        Ctrl+Enter insere.
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 'calc(16px + env(safe-area-inset-bottom))' }}>
                <Button onClick={handleClose} color='inherit'>
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} variant='contained' disabled={!url.trim() || !text.trim()}>
                    Inserir
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LinkInsertDialog;
